
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nft-pools",
      function () {
        return require("private-next-pages/nft-pools/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nft-pools"])
      });
    }
  